module.exports = __webpack_public_path__ + "img/github-brands.06b7e22f.svg";